<!-- MyForm.vue -->
<template>
  <div>

    <b-alert v-if="!authorized" variant="warning" style="font-size:small" show>{{$ml.get("confreadonly")}}</b-alert>

    <b-row>
      <b-col md="3" cols="12" class="leftcolumn">
        <div class="row flex-column">
          <div class="col-sm-12" v-for="element in visibleElements" :key="element">
            <div v-if="element === 'Site Configuration'" class="left-separator"></div>
            <div
              :class="{ 'selected': selectedElement === element }"
              class="selectable"
              @click="selectElement(element)"
            >
              {{ elementLabels[element] || element }}
            </div>
          </div>
        </div>
      </b-col>
      <b-col md="9" cols="12">
        <form @submit.prevent="pushParams">

          <div v-if="selectedElement === 'Global'" class="sdk-panel">
            <div class="form-group sdk-activation-row">

              <span v-if="global.p2pActivated" class="small sdk-status-text">
                Global - {{$ml.get("confactP2Pactiv")}}
              </span>
              <b-btn size="sm" variant="msstreamred" v-if="global.p2pActivated" @click="global.p2pActivated=false" :disabled="!authorized">
                <b-icon icon="slash-circle" />
                {{$ml.get("confdeac")}}
              </b-btn>

              <span v-if="!global.p2pActivated" class="small sdk-status-text">
                Global - {{$ml.get("confdeactP2Pactiv")}}
              </span>
              <b-btn size="sm" variant="green" v-if="!global.p2pActivated" @click="global.p2pActivated=true" :disabled="!authorized">
                <b-icon icon="check2-square" />
                {{$ml.get("confac")}}
              </b-btn>
            </div>

            <b-row class="mb-4 form-group align-items-center global-popularity-row">
              <label class="mt-1 mb-1" for="popularity">{{$ml.get("confactnbr")}}</label>
              <b-input v-model="global.popularity" size="sm" type="number" class="form-control ml-2 global-popularity-input" id="popularity" min="0" required :disabled="!authorized"></b-input>
            </b-row>

            <!-- List of objects -->
            <b-row class="align-items-center mb-3 prevent-range-title prevent-range-heading">
              {{$ml.get("confdactrange")}}
              <b-button size="sm" class="ml-2 mt-1 mb-1 prevent-add-btn" @click.prevent="addGlobalPrevent" variant="darkblue" :disabled="!authorized">+ {{$ml.get("confaddrange")}}</b-button>
            </b-row>

            <div class="prevent-range-list">
              <div class="prevent-range-card" v-for="(item, index) in global.prevents" :key="index">

                <b-row class="align-items-end prevent-range-row">

                  <b-col cols="12" lg="3">
                    <div class="form-group prevent-field">
                      <label v-if="item.type !== 'urlTemplate'">{{$ml.get('typeP2PDeactivated')}}:</label>
                      <label v-else>{{$ml.get('typeLabel')}}:</label>
                      <select v-model="item.type" class="form-control prevent-input" :disabled="!authorized">
                        <option value="urlTemplate">{{$ml.get('urlTemplateOption')}}</option>
                        <option value="segment">{{$ml.get('segmentNumberOption')}}</option>
                        <!--<option value="timestamp">{{$ml.get('streamTimestampOption')}}</option>-->
                        <option value="time">{{$ml.get('timeUtcOption')}}</option>
                      </select>
                    </div>
                  </b-col>

                  <b-col v-if="item.type !== 'urlTemplate'" cols="12" md="4" lg="3">
                    <div class="form-group prevent-field">
                      <label>{{$ml.get("start")}}</label>
                      <input v-model="item.start" type="text" class="form-control prevent-input" required :disabled="!authorized">
                    </div>
                  </b-col>

                  <b-col v-if="item.type !== 'urlTemplate'" cols="12" md="4" lg="3">
                    <div class="form-group prevent-field">
                      <label>{{$ml.get("end")}}</label>
                      <input v-model="item.end" type="text" class="form-control prevent-input" required :disabled="!authorized">
                    </div>
                  </b-col>

                  <b-col v-if="item.type === 'urlTemplate'" cols="12" lg="5">
                    <div class="form-group prevent-field">
                      <label>{{$ml.get('templateLabel')}}:</label>
                      <input v-model="item.urlTemplate" type="text" class="form-control prevent-input" required :disabled="!authorized">
                    </div>
                  </b-col>

                  <b-col v-if="item.type === 'urlTemplate'" cols="12" lg="3">
                    <div class="prevent-toggle">
                      <input v-model="item.isExclude" type="checkbox" class="prevent-toggle-input" :id="`isExclude-${index}`" :disabled="!authorized">
                      <label :for="`isExclude-${index}`" class="prevent-toggle-label">
                        {{ item.isExclude ? $ml.get("confdeactemp") : $ml.get("confactemp") }}
                      </label>
                    </div>
                  </b-col>

                  <b-col cols="12" lg="1" class="prevent-action-col">
                    <b-button size="sm" class="prevent-remove-btn" @click.prevent="removeGlobalPrevent(index)" variant="msstreamred" :title="$ml.get('removeRangeTitle')" :disabled="!authorized">
                      <b-icon icon="x-circle" /></b-button>
                  </b-col>

                </b-row>
              </div>
            </div>

            <b-row class="mt-4 mb-4 prevent-range-title align-items-center interisp-row">
              <label class="panel-checkbox-label" for="interIspActivated">{{$ml.get("confinterisp")}}:</label>
              <input v-model="global.interIsp" type="checkbox" class="panel-checkbox-input" id="interIspActivated" :disabled="!authorized">
            </b-row>

            <hr class="global-divider"/>

            <div class="form-group global-range-group">
              <label for="percentActivated">{{$ml.get("confactper")}}</label>
              <input v-model="global.percentActivated" type="range" class="form-control-range" id="percentActivated" min="0" max="100" :disabled="!authorized">
              <b-row class="justify-content-center range-value-row">
                <span class="range-value-badge">{{ global.percentActivated }}%</span>
              </b-row>
            </div>

            <div class="form-group global-range-group">
              <label for="maxUploadPercent">{{$ml.get("confperband")}}</label>
              <input v-model="global.maxUploadPercent" type="range" class="form-control-range" id="maxUploadPercent" min="0" max="100" :disabled="!authorized">
              <b-row class="justify-content-center range-value-row">
                <span class="range-value-badge">{{ global.maxUploadPercent }}%</span>
              </b-row>
            </div>

            <div class="form-group global-check-row">
              <label class="panel-checkbox-label" for="cellularActivated">{{$ml.get("confupcell")}}</label>
              <input v-model="global.cellularActivated" type="checkbox" class="panel-checkbox-input" id="cellularActivated" :disabled="!authorized">
            </div>

            <hr class="global-divider"/>
            <div class="bold mb-2">{{ $ml.get("cdnSelector") }}</div>
            <div class="vss textcolor mb-4">
              {{ $ml.get("cdnSelectorDescription") }}
              <a href="https://doc.quanteec.com/advanced-topics/cdn-load-balancer" target="_blank" rel="noopener noreferrer">
                {{$ml.get("learnMore")}}
                <font-awesome-icon icon="external-link-alt" size="xs"/>
              </a>
            </div>
            <div class="form-group global-range-group">
              <label for="cdnSelectorBandwidthFactorGlobal">{{$ml.get("cdnSelectorBandwidthFactor")}}</label>
              <input v-model="global.cdnSelectorBandwidthFactor" type="range" class="form-control-range" id="cdnSelectorBandwidthFactorGlobal" min="0" max="10" step="1" :disabled="!authorized">
              <b-row class="justify-content-center range-value-row">
                <span class="range-value-badge">{{ global.cdnSelectorBandwidthFactor }}</span>
              </b-row>
            </div>

            <div class="form-group global-range-group">
              <label for="cdnSelectorTtfbFactorGlobal">{{$ml.get("cdnSelectorTtfbFactor")}}</label>
              <input v-model="global.cdnSelectorTtfbFactor" type="range" class="form-control-range" id="cdnSelectorTtfbFactorGlobal" min="0" max="10" step="1" :disabled="!authorized">
              <b-row class="justify-content-center range-value-row">
                <span class="range-value-badge">{{ global.cdnSelectorTtfbFactor }}</span>
              </b-row>
            </div>

          </div>

          <div v-if="selectedElement === 'Web SDK'" class="sdk-panel">
            <div class="form-group sdk-activation-row">

              <span v-if="web.p2pActivated" class="small sdk-status-text">
                Web - {{$ml.get("confactP2Pactiv")}}
              </span>
              <b-btn size="sm" variant="msstreamred" v-if="web.p2pActivated" @click="web.p2pActivated=false" :disabled="!authorized">
                <b-icon icon="slash-circle" />
                {{$ml.get("confdeacw")}}
              </b-btn>
              <span v-if="!web.p2pActivated" class="small sdk-status-text">
                Web - {{$ml.get("confdeactP2Pactiv")}}
              </span>
              <b-btn size="sm" variant="green" v-if="!web.p2pActivated" @click="web.p2pActivated=true" :disabled="!authorized">
                <b-icon icon="check2-square" />
                {{$ml.get("confacw")}}
              </b-btn>

            </div>
            <div class="form-group sdk-form-group">
                <label for="numberOfSegmentsToKeepWeb">{{$ml.get("confnbrseg")}}:</label>
                <input v-model="web.numberOfSegmentsToKeep" type="range" class="form-control-range" id="numberOfSegmentsToKeepWeb" min="0" max="120">
                <b-row class="justify-content-center range-value-row">
                  <span class="range-value-badge">{{ web.numberOfSegmentsToKeep }} {{$ml.get('segmentsUnit')}}</span>
                </b-row>
            </div>

            <b-row class="mt-4 mb-4 prevent-range-title align-items-center interisp-row">
              <label class="panel-checkbox-label" for="webSdkGlobal">{{$ml.get("confglo")}}</label>
              <input v-model="web.useGlobal" type="checkbox" class="panel-checkbox-input" id="webSdkGlobal" :disabled="!authorized">
            </b-row>

            <hr class="sdk-divider"/>

            <div v-if="web.useGlobal">
              <div class="form-group sdk-form-group">
                <label for="percentActivated">{{$ml.get("confactper")}}</label>
                <input v-model="global.percentActivated" type="range" class="form-control-range" id="percentActivated" min="0" max="100" disabled>
                <b-row class="justify-content-center range-value-row">
                  <span class="range-value-badge">{{ global.percentActivated }}%</span>
                </b-row>
              </div>

              <div class="form-group sdk-form-group">
                <label for="maxUploadPercent">{{$ml.get("confperband")}}</label>
                <input v-model="global.maxUploadPercent" type="range" class="form-control-range" id="maxUploadPercent" min="0" max="100" disabled>
                <b-row class="justify-content-center range-value-row">
                  <span class="range-value-badge">{{ global.maxUploadPercent }}%</span>
                </b-row>
              </div>

              <b-row class="mt-4 mb-4 prevent-range-title align-items-center interisp-row">
                <label class="panel-checkbox-label" for="cellularActivated">{{$ml.get("confupcell")}}</label>
                <input v-model="global.cellularActivated" type="checkbox" class="panel-checkbox-input" id="cellularActivated" disabled>
              </b-row>
            </div>

            <div v-if="!web.useGlobal">
              <div class="form-group sdk-form-group">
                <label for="percentActivated">{{$ml.get("confactper")}}</label>
                <input v-model="web.percentActivated" type="range" class="form-control-range" id="percentActivated" min="0" max="100" :disabled="!authorized">
                <b-row class="justify-content-center range-value-row">
                  <span class="range-value-badge">{{ web.percentActivated }}%</span>
                </b-row>
              </div>

              <div class="form-group sdk-form-group">
                <label for="maxUploadPercent">{{$ml.get("confperband")}}</label>
                <input v-model="web.maxUploadPercent" type="range" class="form-control-range" id="maxUploadPercent" min="0" max="100" :disabled="!authorized">
                <b-row class="justify-content-center range-value-row">
                  <span class="range-value-badge">{{ web.maxUploadPercent }}%</span>
                </b-row>
              </div>

              <b-row class="mt-4 mb-4 prevent-range-title align-items-center interisp-row">
                <label class="panel-checkbox-label" for="cellularActivated">{{$ml.get("confupcell")}}</label>
                <input v-model="web.cellularActivated" type="checkbox" class="panel-checkbox-input" id="cellularActivated" :disabled="!authorized">
              </b-row>

              <hr class="sdk-divider"/>
              <div class="bold mb-2">{{ $ml.get("cdnSelector") }}</div>
              <div class="vss textcolor mb-4">
                {{ $ml.get("cdnSelectorDescription") }}
                <a href="https://doc.quanteec.com/advanced-topics/cdn-load-balancer" target="_blank" rel="noopener noreferrer">
                  {{$ml.get("learnMore")}}
                  <font-awesome-icon icon="external-link-alt" size="xs"/>
                </a>
              </div>
              <div class="form-group sdk-form-group">
                <label for="cdnSelectorBandwidthFactorWeb">{{$ml.get("cdnSelectorBandwidthFactor")}}</label>
                <input v-model="web.cdnSelectorBandwidthFactor" type="range" class="form-control-range" id="cdnSelectorBandwidthFactorWeb" min="0" max="10" step="1" :disabled="!authorized">
                <b-row class="justify-content-center range-value-row">
                  <span class="range-value-badge">{{ web.cdnSelectorBandwidthFactor }}</span>
                </b-row>
              </div>
              <div class="form-group sdk-form-group">
                <label for="cdnSelectorTtfbFactorWeb">{{$ml.get("cdnSelectorTtfbFactor")}}</label>
                <input v-model="web.cdnSelectorTtfbFactor" type="range" class="form-control-range" id="cdnSelectorTtfbFactorWeb" min="0" max="10" step="1" :disabled="!authorized">
                <b-row class="justify-content-center range-value-row">
                  <span class="range-value-badge">{{ web.cdnSelectorTtfbFactor }}</span>
                </b-row>
              </div>

            </div>
          </div>

          <div v-if="selectedElement === 'Android SDK'" class="sdk-panel">
            <div class="form-group sdk-activation-row">

              <span v-if="android.p2pActivated" class="small sdk-status-text">
                Android - {{$ml.get("confactP2Pactiv")}}
              </span>
              <b-btn size="sm" variant="msstreamred" v-if="android.p2pActivated" @click="android.p2pActivated=false" :disabled="!authorized">
                <b-icon icon="slash-circle" />
                {{$ml.get("confdeaca")}}
              </b-btn>
              <span v-if="!android.p2pActivated" class="small sdk-status-text">
                Android - {{$ml.get("confdeactP2Pactiv")}}
              </span>
              <b-btn size="sm" variant="green" v-if="!android.p2pActivated" @click="android.p2pActivated=true" :disabled="!authorized">
                <b-icon icon="check2-square" />
                {{$ml.get("confaca")}}
              </b-btn>
            </div>
            <b-row class="mt-4 mb-4 prevent-range-title align-items-center interisp-row">
              <label class="panel-checkbox-label" for="androidSdkGlobal">{{$ml.get("confglo")}}</label>
              <input v-model="android.useGlobal" type="checkbox" class="panel-checkbox-input" id="androidSdkGlobal" :disabled="!authorized">
            </b-row>
            <hr class="sdk-divider"/>
            <div v-if="android.useGlobal">
              <div class="form-group sdk-form-group">
                <label for="percentActivated">{{$ml.get("confactper")}}</label>
                <input v-model="global.percentActivated" type="range" class="form-control-range" id="percentActivated" min="0" max="100" disabled>
                <b-row class="justify-content-center range-value-row">
                  <span class="range-value-badge">{{ global.percentActivated }}%</span>
                </b-row>
              </div>

              <div class="form-group sdk-form-group">
                <label for="maxUploadPercent">{{$ml.get("confperband")}}</label>
                <input v-model="global.maxUploadPercent" type="range" class="form-control-range" id="maxUploadPercent" min="0" max="100" disabled>
                <b-row class="justify-content-center range-value-row">
                  <span class="range-value-badge">{{ global.maxUploadPercent }}%</span>
                </b-row>
              </div>

              <b-row class="mt-4 mb-4 prevent-range-title align-items-center interisp-row">
                <label class="panel-checkbox-label" for="cellularActivated">{{$ml.get("confupcell")}}</label>
                <input v-model="global.cellularActivated" type="checkbox" class="panel-checkbox-input" id="cellularActivated" disabled>
              </b-row>
            </div>

            <div v-if="!android.useGlobal">
              <div class="form-group sdk-form-group">
                <label for="percentActivated">{{$ml.get("confactper")}}</label>
                <input v-model="android.percentActivated" type="range" class="form-control-range" id="percentActivated" min="0" max="100" :disabled="!authorized">
                <b-row class="justify-content-center range-value-row">
                  <span class="range-value-badge">{{ android.percentActivated }}%</span>
                </b-row>
              </div>

              <div class="form-group sdk-form-group">
                <label for="maxUploadPercent">{{$ml.get("confperband")}}</label>
                <input v-model="android.maxUploadPercent" type="range" class="form-control-range" id="maxUploadPercent" min="0" max="100" :disabled="!authorized">
                <b-row class="justify-content-center range-value-row">
                  <span class="range-value-badge">{{ android.maxUploadPercent }}%</span>
                </b-row>
              </div>

              <b-row class="mt-4 mb-4 prevent-range-title align-items-center interisp-row">
                <label class="panel-checkbox-label" for="cellularActivated">{{$ml.get("confupcell")}}</label>
                <input v-model="android.cellularActivated" type="checkbox" class="panel-checkbox-input" id="cellularActivated" :disabled="!authorized">
              </b-row>

              <hr class="sdk-divider"/>
              <div class="bold mb-2">{{ $ml.get("cdnSelector") }}</div>
              <div class="vss textcolor mb-4">
                {{ $ml.get("cdnSelectorDescription") }}
                <a href="https://doc.quanteec.com/advanced-topics/cdn-load-balancer" target="_blank" rel="noopener noreferrer">
                  {{$ml.get("learnMore")}}
                  <font-awesome-icon icon="external-link-alt" size="xs"/>
                </a>
              </div>
              <div class="form-group sdk-form-group">
                <label for="cdnSelectorBandwidthFactorAndroid">{{$ml.get("cdnSelectorBandwidthFactor")}}</label>
                <input v-model="android.cdnSelectorBandwidthFactor" type="range" class="form-control-range" id="cdnSelectorBandwidthFactorAndroid" min="0" max="10" step="1" :disabled="!authorized">
                <b-row class="justify-content-center range-value-row">
                  <span class="range-value-badge">{{ android.cdnSelectorBandwidthFactor }}</span>
                </b-row>
              </div>
              <div class="form-group sdk-form-group">
                <label for="cdnSelectorTtfbFactorAndroid">{{$ml.get("cdnSelectorTtfbFactor")}}</label>
                <input v-model="android.cdnSelectorTtfbFactor" type="range" class="form-control-range" id="cdnSelectorTtfbFactorAndroid" min="0" max="10" step="1" :disabled="!authorized">
                <b-row class="justify-content-center range-value-row">
                  <span class="range-value-badge">{{ android.cdnSelectorTtfbFactor }}</span>
                </b-row>
              </div>
            </div>
          </div>

          <div v-if="selectedElement === 'iOS SDK'" class="sdk-panel">
            <div class="form-group sdk-activation-row">

              <span v-if="ios.p2pActivated" class="small sdk-status-text">
                iOS - {{$ml.get("confactP2Pactiv")}}
              </span>
              <b-btn size="sm" variant="msstreamred" v-if="ios.p2pActivated" @click="ios.p2pActivated=false" :disabled="!authorized">
                <b-icon icon="slash-circle" />
                {{$ml.get("confdeaci")}}
              </b-btn>
              <span v-if="!ios.p2pActivated" class="small sdk-status-text">
                iOS - {{$ml.get("confdeactP2Pactiv")}}
              </span>
              <b-btn size="sm" variant="green" v-if="!ios.p2pActivated" @click="ios.p2pActivated=true" :disabled="!authorized">
                <b-icon icon="check2-square" />
                {{$ml.get("confdeaci")}}
              </b-btn>
            </div>
            <b-row class="mt-4 mb-4 prevent-range-title align-items-center interisp-row">
              <label class="panel-checkbox-label" for="iosSdkGlobal">{{$ml.get("confglo")}}</label>
              <input v-model="ios.useGlobal" type="checkbox" class="panel-checkbox-input" id="iosSdkGlobal" :disabled="!authorized">
            </b-row>
            <hr class="sdk-divider"/>
            <div v-if="ios.useGlobal">
              <div class="form-group sdk-form-group">
                <label for="percentActivated">{{$ml.get("confactper")}}</label>
                <input v-model="global.percentActivated" type="range" class="form-control-range" id="percentActivated" min="0" max="100" disabled>
                <b-row class="justify-content-center range-value-row">
                  <span class="range-value-badge">{{ global.percentActivated }}%</span>
                </b-row>
              </div>

              <div class="form-group sdk-form-group">
                <label for="maxUploadPercent">{{$ml.get("confperband")}}</label>
                <input v-model="global.maxUploadPercent" type="range" class="form-control-range" id="maxUploadPercent" min="0" max="100" disabled>
                <b-row class="justify-content-center range-value-row">
                  <span class="range-value-badge">{{ global.maxUploadPercent }}%</span>
                </b-row>
              </div>

              <b-row class="mt-4 mb-4 prevent-range-title align-items-center interisp-row">
                <label class="panel-checkbox-label" for="cellularActivated">{{$ml.get("confupcell")}}</label>
                <input v-model="global.cellularActivated" type="checkbox" class="panel-checkbox-input" id="cellularActivated" disabled>
              </b-row>
            </div>

            <div v-if="!ios.useGlobal">
              <div class="form-group sdk-form-group">
                <label for="percentActivated">{{$ml.get("confactper")}}</label>
                <input v-model="ios.percentActivated" type="range" class="form-control-range" id="percentActivated" min="0" max="100" :disabled="!authorized">
                <b-row class="justify-content-center range-value-row">
                  <span class="range-value-badge">{{ ios.percentActivated }}%</span>
                </b-row>
              </div>

              <div class="form-group sdk-form-group">
                <label for="maxUploadPercent">{{$ml.get("confperband")}}</label>
                <input v-model="ios.maxUploadPercent" type="range" class="form-control-range" id="maxUploadPercent" min="0" max="100" :disabled="!authorized">
                <b-row class="justify-content-center range-value-row">
                  <span class="range-value-badge">{{ ios.maxUploadPercent }}%</span>
                </b-row>
              </div>

              <b-row class="mt-4 mb-4 prevent-range-title align-items-center interisp-row">
                <label class="panel-checkbox-label" for="cellularActivated">{{$ml.get("confupcell")}}</label>
                <input v-model="ios.cellularActivated" type="checkbox" class="panel-checkbox-input" id="cellularActivated" :disabled="!authorized">
              </b-row>

              <hr class="sdk-divider"/>
              <div class="bold mb-2">{{ $ml.get("cdnSelector") }}</div>
              <div class="vss textcolor mb-4">
                {{ $ml.get("cdnSelectorDescription") }}
                <a href="https://doc.quanteec.com/advanced-topics/cdn-load-balancer" target="_blank" rel="noopener noreferrer">
                  {{$ml.get("learnMore")}}
                  <font-awesome-icon icon="external-link-alt" size="xs"/>
                </a>
              </div>
              <div class="form-group sdk-form-group">
                <label for="cdnSelectorBandwidthFactoriOS">{{$ml.get("cdnSelectorBandwidthFactor")}}</label>
                <input v-model="ios.cdnSelectorBandwidthFactor" type="range" class="form-control-range" id="cdnSelectorBandwidthFactoriOS" min="0" max="10" step="1" :disabled="!authorized">
                <b-row class="justify-content-center range-value-row">
                  <span class="range-value-badge">{{ ios.cdnSelectorBandwidthFactor }}</span>
                </b-row>
              </div>
              <div class="form-group sdk-form-group">
                <label for="cdnSelectorTtfbFactoriOS">{{$ml.get("cdnSelectorTtfbFactor")}}</label>
                <input v-model="ios.cdnSelectorTtfbFactor" type="range" class="form-control-range" id="cdnSelectorTtfbFactoriOS" min="0" max="10" step="1" :disabled="!authorized">
                <b-row class="justify-content-center range-value-row">
                  <span class="range-value-badge">{{ ios.cdnSelectorTtfbFactor }}</span>
                </b-row>
              </div>
            </div>
          </div>

          <div v-if="selectedElement === 'Authorizations'">
            <b-row class="align-items-center justify-content-around mb-3">
              <b-col md="5" style="text-align:center; font-weight:bold; color:#14BF98">Whitelists</b-col>
              <b-col cols="2"></b-col>
              <b-col md="5" style="text-align:center; font-weight:bold; color:red">Blacklists</b-col>
            </b-row>
            <b-row class="align-items-center justify-content-around">
              <b-col md="5" style="text-align:center">
                <b-form-radio size="sm" v-model="authorizations.isAuthorizedIPs" name="some-radiosIP" :value="true" :disabled="!authorized">
                  <font-awesome-icon style="color: #14BF98" :icon="['fas', 'check-circle']" />
                  &nbsp;{{$ml.get('pluginvideoauthip2')}}
                </b-form-radio>
              </b-col>
              <b-col cols="2" style="font-size:small; text-align:center">
                - {{$ml.get('or')}} -
              </b-col>
              <b-col md="5" style="text-align:center">
                <b-form-radio size="sm" v-model="authorizations.isAuthorizedIPs" name="some-radiosIP" :value="false" :disabled="!authorized">
                  <font-awesome-icon style="color: red" :icon="['fas', 'minus-circle']" />
                  &nbsp;{{$ml.get('pluginvideounauthip2')}}
                </b-form-radio>
              </b-col>
            </b-row>
            <b-row class="align-items-center">
              <p class="col-md-6" style="font-size:10px; margin-bottom:8px" v-html="$ml.get('pluginvideop5')"></p>
              <p class="col-md-6" style="font-size:10px; margin-bottom:8px" v-html="$ml.get('pluginvideop6')"></p>
            </b-row>
            <b-row class="justify-content-around align-items-center mb-4">
              <tags-input class="col-md-6" element-id="tagsaIP" :disabled="!authorizations.isAuthorizedIPs || !authorized" style="font-size:small"
                v-model="authorizationsTags._authorizedIPs" :placeholder="$ml.get('ipAddressPlusEnter')"></tags-input>
              <tags-input class="col-md-6" element-id="tagsuIP" :key="'tagsuIP-' + authorizations.isAuthorizedIPs" :disabled="authorizations.isAuthorizedIPs || !authorized" style="font-size:small"
                v-model="authorizationsTags._unauthorizedIPs" :placeholder="$ml.get('ipAddressPlusEnter')"></tags-input>
            </b-row>

            <b-row class="align-items-center justify-content-around">
              <b-col md="5" style="text-align:center">
                <b-form-radio size="sm" v-model="authorizations.isAuthorizedCountries"  name="some-radiosC" :value="true" :disabled="!authorized">
                  <font-awesome-icon style="color: #14BF98" :icon="['fas', 'check-circle']" />
                  &nbsp;{{$ml.get('pluginvideoauthcountry2')}}
                </b-form-radio>
              </b-col>
              <b-col cols="2" style="font-size:small; text-align:center">
                - {{$ml.get('or')}} -
              </b-col>
              <b-col md="5" style="text-align:center">
                <b-form-radio size="sm" v-model="authorizations.isAuthorizedCountries"  name="some-radiosC" :value="false" :disabled="!authorized">
                  <font-awesome-icon style="color: red" :icon="['fas', 'minus-circle']" />
                  &nbsp;{{$ml.get('pluginvideounauthcountry2')}}
                </b-form-radio>
              </b-col>
            </b-row>

            <b-row class="align-items-center">
              <p class="col-md-6" style="font-size:10px; margin-bottom:8px" v-html="$ml.get('pluginvideop7')"></p>
              <p class="col-md-6" style="font-size:10px; margin-bottom:8px" v-html="$ml.get('pluginvideop8')"></p>
            </b-row>
            <b-row class="justify-content-around align-items-center mb-4">
              <tags-input class="col-md-6" element-id="tagsaC" :disabled="!authorizations.isAuthorizedCountries || !authorized" style="font-size:small"
                v-model="authorizationsTags._authorizedCountries" :placeholder="$ml.get('countryPlusEnter')"></tags-input>
              <tags-input class="col-md-6" element-id="taguCs" :key="'taguCs-' + authorizations.isAuthorizedCountries" :disabled="authorizations.isAuthorizedCountries || !authorized" style="font-size:small"
                v-model="authorizationsTags._unauthorizedCountries" :placeholder="$ml.get('countryPlusEnter')"></tags-input>
            </b-row>

            <b-row class="align-items-center justify-content-around">
              <b-col md="5" style="text-align:center">
                <b-form-radio size="sm" v-model="authorizations.isAuthorizedWebsites"  name="some-radiosW" :value="true" :disabled="!authorized">
                  <font-awesome-icon style="color: #14BF98" :icon="['fas', 'check-circle']" />
                  &nbsp;{{$ml.get('pluginvideowhitewb')}}
                </b-form-radio>
              </b-col>
              <b-col cols="2" style="font-size:small; text-align:center">
                - {{$ml.get('or')}} -
              </b-col>
              <b-col md="5" style="text-align:center">
                <b-form-radio size="sm" v-model="authorizations.isAuthorizedWebsites"  name="some-radiosW" :value="false" :disabled="!authorized">
                  <font-awesome-icon style="color: red" :icon="['fas', 'minus-circle']" />
                  &nbsp;{{$ml.get('pluginvideoblackwb')}}
                </b-form-radio>
              </b-col>
            </b-row>
            <b-row class="align-items-center">
              <p class="col-md-6" style="font-size:10px; margin-bottom:8px" v-html="$ml.get('pluginvideop9')"></p>
              <p class="col-md-6" style="font-size:10px; margin-bottom:8px" v-html="$ml.get('pluginvideop10')"></p>
            </b-row>
            <b-row class="justify-content-around align-items-center mb-4">
              <tags-input class="col-md-6" element-id="tagsaW" :disabled="!authorizations.isAuthorizedWebsites || !authorized" style="font-size:small"
                v-model="authorizationsTags._whitelistedWebsites" :placeholder="$ml.get('websitePlusEnter')"></tags-input>
              <tags-input class="col-md-6" element-id="tagsuW" :key="'tagsuW-' + authorizations.isAuthorizedWebsites" :disabled="authorizations.isAuthorizedWebsites || !authorized" style="font-size:small"
                v-model="authorizationsTags._blacklistedWebsites" :placeholder="$ml.get('websitePlusEnter')"></tags-input>
            </b-row>

            <b-row class="justify-content-center">
              <b-form-checkbox size="sm" id="isStreamingModal" v-model="authorizations.isAuthorizedVPNs" switch :disabled="!authorized">
                &nbsp;
                <font-awesome-icon v-if="authorizations.isAuthorizedVPNs" style="color: #14BF98" :icon="['fas', 'check-circle']" />
                <font-awesome-icon v-if="!authorizations.isAuthorizedVPNs" style="color: red" :icon="['fas', 'minus-circle']" />
                {{
                  authorizations.isAuthorizedVPNs
                  ? $ml.get('pluginvideoisvpn')
                  : $ml.get('pluginvideoisnotvpn')
                }}
              </b-form-checkbox>
            </b-row>
            <b-row v-if="!authorizations.isAuthorizedVPNs" class="justify-content-center mb-4">
              <tags-input element-id="tags" style="font-size:small; width:250px"
                v-model="authorizationsTags._authorizedVPNsList" :placeholder="$ml.get('ipAddressPlusEnter')" :disabled="!authorized"></tags-input>
            </b-row>
          </div>

          <div v-if="selectedElement === 'Site Configuration' && showSiteTab" class="mt-3 sdk-panel site-panel-scroll">
            <b-alert v-if="!authorized" variant="warning" show>{{$ml.get('readOnly')}}</b-alert>

            <div class="site-panel-header mb-4">
              <b-icon icon="diagram3-fill" />
              {{$ml.get('siteexplainConfig')}}
            </div>

            <b-form-checkbox
              size="sm"
              id="otherP2Pcheck"
              v-model="otherP2P"
              name="otherP2P"
              @change="pushOtherP2P"
              class="otherP2P"
              switch
              :disabled="!authorized"
            >
              <b-icon v-if="otherP2P" icon="unlock-fill" />
              <b-icon v-if="!otherP2P" icon="lock-fill" />&nbsp;{{$ml.get('acceptundeclaresite')}}
            </b-form-checkbox>

            <b-table
              bordered
              responsive
              striped
              hover
              small
              :busy="isSiteLoading"
              :items="sites"
              :fields="siteFields"
              class="site-table mt-3 mb-3"
            >
              <template #table-busy>
                <div class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>{{$ml.get('loadingConfig')}}</strong>
                </div>
              </template>

              <template #cell(Public_IPs)="row">
                <span>[{{(row.item.publicIPs.join(', ').length > 50) ? row.item.publicIPs.join(', ').substring(0,50) + '...' : row.item.publicIPs.join(', ')}}]</span>
              </template>

              <template #cell(Subnets)="row">
                <span>[{{(row.item.subNetworks.join(', ').length > 50) ? row.item.subNetworks.join(', ').substring(0,50) + '...' : row.item.subNetworks.join(', ')}}]</span>
              </template>

              <template #cell(modif)="row">
                <b-button size="sm" variant="msstreamblue" @click="analyticsSite(row.index, row.item)" v-if="$auth.validateRoles(['readAnalytics'])">
                  <b-icon icon="graph-up" />
                </b-button>
                &nbsp;
                <b-button size="sm" variant="mswarning" @click="modifySite(row.item, row.index)" :disabled="!authorized">
                  <b-icon icon="pencil-square" />
                </b-button>
                &nbsp;
                <b-button size="sm" variant="msstreamred" @click="removeSite(row.index, row.item)" :disabled="!authorized">
                  <b-icon icon="x" />
                </b-button>
              </template>
            </b-table>

            <b-row class="justify-content-center mb-2">
              <b-col cols="auto">
                <b-btn size="sm" variant="msstreamblue" @click="addSite" :disabled="!authorized">
                  <b-icon icon="check2-square" />
                  {{$ml.get('addasite')}}
                </b-btn>
              </b-col>
            </b-row>

            <div v-if="isSiteFormActivated" class="marginaltop">
              <hr>
              <h6>{{$ml.get('entersiteinfo')}}</h6>
              <b-form @submit.prevent="" class="site-form">
                <b-form-group
                  id="sitenameformlabel"
                  :label="$ml.get('namesite')"
                  label-for="sitenameform"
                >
                  <b-form-input size="sm" id="sitenameform" v-model="modifiedSite.name" required :disabled="!authorized"></b-form-input>
                </b-form-group>

                <b-form-group
                  id="sitetypeformlabel"
                  :label="$ml.get('p2pconf')"
                  label-for="sitetypeform"
                >
                  <b-form-select size="sm" id="sitetypeform" v-model="modifiedSite.p2pType" :options="siteP2POptions" required :disabled="!authorized"></b-form-select>
                </b-form-group>

                <div class="marginaltop">
                  <b-form @submit.prevent="addPublicIP">
                    <b-form-group
                      id="publicipsformlabel"
                      :label="$ml.get('IPpub')"
                      label-for="publicipsform"
                    >
                      <b-form-input size="sm" id="publicipsform" :state="publicIPValidation" v-model="newPublicIP" :disabled="!authorized"></b-form-input>
                      <b-form-valid-feedback :state="publicIPValidation">
                        {{$ml.get('validIPlist')}}
                      </b-form-valid-feedback>
                      <b-form-invalid-feedback :state="publicIPValidation">
                        {{$ml.get('validIPCIDR')}}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </b-form>

                  <b-row v-if="modifiedSite.publicIPs && modifiedSite.publicIPs.length > 0" class="marginaltopsm">
                    <b-col style="margin-bottom: 10px;" cols="auto" v-for="(publicIP, idxPublicIP) in modifiedSite.publicIPs" :key="idxPublicIP">
                      <small class="ip">{{publicIP}} <span class="ipremove" @click="removePublicIP(idxPublicIP)">X</span></small>
                    </b-col>
                  </b-row>
                </div>

                <div :class="{'marginaltop': modifiedSite.publicIPs.length === 0,'marginaltopsm': modifiedSite.publicIPs.length > 0}">
                  <b-form @submit.prevent="addSubnet">
                    <b-form-group
                      id="subnetsformlabel"
                      :label="$ml.get('subnets')"
                      label-for="subnetsform"
                      :description="$ml.get('subnetsinCIDR')"
                    >
                      <b-form-input size="sm" id="subnetsform" :state="subnetValidation" v-model="newSubnet" :disabled="!authorized"></b-form-input>
                      <b-form-valid-feedback :state="subnetValidation">
                        {{$ml.get('validSublist')}}
                      </b-form-valid-feedback>
                      <b-form-invalid-feedback :state="subnetValidation">
                        {{$ml.get('validSublistCIDR')}}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </b-form>

                  <b-row v-if="modifiedSite.subNetworks && modifiedSite.subNetworks.length > 0" class="marginaltopsm">
                    <b-col style="margin-bottom: 10px;" cols="auto" v-for="(subNetwork, idxSubNetwork) in modifiedSite.subNetworks" :key="idxSubNetwork">
                      <small class="ip">{{subNetwork}} <span class="ipremove" @click="removeSubnet(idxSubNetwork)">X</span></small>
                    </b-col>
                  </b-row>
                </div>

                <b-row class="justify-content-end marginaltopsm">
                  <b-col cols="auto">
                    <b-btn size="sm" variant="msstreamblue" @click="pushSite" :disabled="!authorized">
                      <b-icon icon="check2-circle" />
                      {{$ml.get('save')}}
                    </b-btn>
                  </b-col>
                  <b-col cols="auto">
                    <b-button size="sm" variant="mswarning" @click="isSiteFormActivated=false">
                    <b-icon icon="arrow-counterclockwise" />
                    {{$ml.get('cancel')}}
                    </b-button>
                  </b-col>
                </b-row>
              </b-form>
            </div>
          </div>

          <hr />
          <div v-if="selectedElement !== 'Site Configuration'" class="flex-column d-flex justify-content-end" style="margin-top:2rem">
            <div class="flex-fill">
              <b-row class="justify-content-around">
                  <b-button type="submit" variant="msstreamblue" :disabled="!authorized || !hasChanges">
                    <b-icon icon="check2-circle" />
                    {{$ml.get("submit")}}
                  </b-button>
                  <b-button variant="mswarning" :disabled="!hasChanges" @click="resetToInitial">
                    <b-icon icon="arrow-counterclockwise" />
                    {{$ml.get('cancel')}}
                  </b-button>
                  <b-button v-if="type === 'video'" variant="mswarning" @click="defaultParams" :disabled="!authorized">
                    <b-icon icon="key" rotate="45" />
                    {{$ml.get("confdefaultparam")}}
                  </b-button>
              </b-row>
            </div>
          </div>
        </form>
      </b-col>
    </b-row>

    <b-modal ref="successParameters" hide-footer :title="$ml.get('parameters')" modal-class="parameters-modal">
      <small class="parameters-modal-text">{{$ml.get('parameterstxt')}}</small>
      <hr class="parameters-modal-divider" />
      <b-row class="justify-content-around parameters-modal-actions">
        <b-btn size="sm" class="col-md-3 col-5 parameters-modal-close" variant="quanteeclg" @click="hideModal('successParameters')">
          <font-awesome-icon class="parameters-modal-close-icon" :icon="['fas', 'times']" />
          {{$ml.get('close')}}
        </b-btn>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import {v4 as uuidv4} from 'uuid';
import VideoService from '@/services/video.service.js';
import ConfigurationService from '@/services/configuration.service.js';
import CollectionService from '@/services/collection.service.js';
import _ from 'lodash';

let videoService = new VideoService();
let configurationService = new ConfigurationService();
let collectionService = new CollectionService();

export default {
  name: 'configparamform',
  data() {
    return {
      elements: ['Global', 'Web SDK', 'Android SDK', 'iOS SDK', 'Authorizations'],
      selectedElement: 'Global',
      authorized: ((this.type === "config" && this.$auth.validateRoles(['modifyConfigurations'])) || (this.type !== "config" && this.$auth.validateRoles(['modifyVideos']))),
      initialState: null,
      isSiteLoading: false,
      configurationID: null,
      otherP2P: false,
      sites: [],
      isSiteFormActivated: false,
      modificationIndex: -1,
      modifiedSite: {
        name: '',
        uuid: '',
        p2pType: 'strict_subnet',
        subNetworks: [],
        publicIPs: []
      },
      newPublicIP: '',
      newSubnet: '',
      global: {
        p2pActivated: true,
        popularity: 0,
        percentActivated: 100,
        maxUploadPercent: 100,
        cellularActivated: false,
        interIsp: true,
        prevents: [

        ],
        cdnSelectorBandwidthFactor: 1,
        cdnSelectorTtfbFactor: 1,
      },
      web: {
        p2pActivated: true,
        useGlobal: true,
        percentActivated: 100,
        maxUploadPercent: 100,
        numberOfSegmentsToKeep: 20,
        cellularActivated: false,
        cdnSelectorBandwidthFactor: 1,
        cdnSelectorTtfbFactor: 1,
      },
      android: {
        p2pActivated: true,
        useGlobal: true,
        percentActivated: 100,
        maxUploadPercent: 100,
        cellularActivated: false,
        cdnSelectorBandwidthFactor: 1,
        cdnSelectorTtfbFactor: 1,
      },
      ios: {
        p2pActivated: true,
        useGlobal: true,
        percentActivated: 100,
        maxUploadPercent: 100,
        cellularActivated: false,
        cdnSelectorBandwidthFactor: 1,
        cdnSelectorTtfbFactor: 1,
      },
      authorizations: {
        isAuthorizedIPs: true,
        isAuthorizedCountries: true,
        isAuthorizedWebsites: true,
        isAuthorizedVPNs: true,
        authorizedIPs: [],
        unauthorizedIPs: [],
        authorizedCountries: [],
        unauthorizedCountries: [],
        whitelistedWebsites: [],
        blacklistedWebsites: [],
        authorizedVPNsList: []
      },
      authorizationsTags: {
        _authorizedIPs: [],
        _unauthorizedIPs: [],
        _authorizedCountries: [],
        _unauthorizedCountries: [],
        _whitelistedWebsites: [],
        _blacklistedWebsites: [],
        _authorizedVPNsList: []
      }
    };
  },
  props: [
    "type",
    "config",
    "video",
    "collection",
    "readonly"
  ],
  mounted() {
    console.log("Instanciated", this.type, this.video, this.config, this.collection, this.readonly)
    if (this.readonly) {
      this.authorized = false;
    }

    if (this.showSiteTab) {
      this.loadSiteConfiguration();
    }

    switch(this.type) {
      case 'config':
        this.getParamsForConfig()
        break;
      case 'video':
        this.getParamsForVideo()
        break;
      case 'collection':
        this.getParamsForCollection()
        break;
      default:
        console.log('Unknown parameter type')
    }
    this.validateDefaultValues();
    this.$nextTick(() => {
      this.initialState = this.captureState();
    });
  },
  computed: {
    showSiteTab() {
      return this.type === 'config' && this.$auth.getMyUser().client_infos && this.$auth.getMyUser().client_infos[0] && this.$auth.getMyUser().client_infos[0].ecdn;
    },
    visibleElements() {
      if (this.showSiteTab) {
        return [...this.elements, 'Site Configuration'];
      }
      return this.elements;
    },
    elementSelected() {
      return this.elements.findIndex(x => x === this.selectedElement);
    },
    elementLabels() {
      return {
        'Global': this.$ml.get('globalLabel'),
        'Authorizations': this.$ml.get('authorizationsLabel'),
        'Web SDK': this.$ml.get('webSdkLabel'),
        'Android SDK': this.$ml.get('androidSdkLabel'),
        'iOS SDK': this.$ml.get('iosSdkLabel'),
        'Site Configuration': this.$ml.get('siteListConfigSimple'),
      }
    },
    siteFields() {
      return [
        {
          key: 'name',
          label: this.$ml.get('nameField'),
          tdClass: 'align-middle',
          sortable: true
        },
        {
          key: 'Public_IPs',
          tdClass: 'align-middle',
          label: this.$ml.get('publicIPsField')
        },
        {
          key: 'Subnets',
          tdClass: 'align-middle',
        },
        {
          key: 'p2pType',
          label: this.$ml.get('p2pActivatedField'),
          tdClass: 'align-middle',
          sortable: true
        },
        {
          key: 'updatedAt',
          label: this.$ml.get('lastUpdatedField'),
          tdClass: 'align-middle',
          sortable: true
        },
        {
          key: 'modif',
          sortable: false,
          tdClass: 'align-middle text-center',
          label: ''
        },
      ];
    },
    siteP2POptions() {
      return [
        { value: 'strict_subnet', text: this.$ml.get('p2pStrictSubnet') },
        { value: 'subnet', text: this.$ml.get('p2pSubnet') },
        { value: 'intrasite', text: this.$ml.get('p2pIntrasite') },
        { value: 'off', text: this.$ml.get('p2pOff') },
      ];
    },
    publicIPValidation() {
      if (this.newPublicIP === '') {
        return null;
      }
      return this.newPublicIP.match(/^([0-9]{1,3}\.){3}[0-9]{1,3}(\/([0-9]|[1-2][0-9]|3[0-2]))?$/g) !== null;
    },
    subnetValidation() {
      if (this.newSubnet === '') {
        return null;
      }
      return this.newSubnet.match(/^([0-9]{1,3}\.){3}[0-9]{1,3}(\/([0-9]|[1-2][0-9]|3[0-2]))$/g) !== null;
    },
    hasChanges() {
      if (!this.initialState) return false;
      return JSON.stringify(this.captureState()) !== JSON.stringify(this.initialState);
    }
  },
  methods: {
    captureState() {
      return JSON.parse(JSON.stringify({
        global: this.global,
        web: this.web,
        android: this.android,
        ios: this.ios,
        authorizations: this.authorizations,
        authorizationsTags: this.authorizationsTags,
      }));
    },
    resetToInitial() {
      if (!this.initialState) return;
      const s = JSON.parse(JSON.stringify(this.initialState));
      this.global = s.global;
      this.web = s.web;
      this.android = s.android;
      this.ios = s.ios;
      this.authorizations = s.authorizations;
      this.authorizationsTags = s.authorizationsTags;
    },
    showModal(modal) {
      this.$refs[modal].show();
    },
    hideModal(modal) {
      this.$refs[modal].hide();
    },
    submitForm() {
      console.log("Form submitted");
    },
    selectElement(element) {
      this.selectedElement = element;
    },
    addGlobalPrevent() {
      this.global.prevents.push({ type: 'urlTemplate', start: '', end: '', urlTemplate: '', isExclude:  true});
    },
    removeGlobalPrevent(index) {
      this.global.prevents.splice(index, 1);
    },
    loadSiteConfiguration() {
      if (!this.config || !this.config.uuid) {
        return;
      }

      this.isSiteLoading = true;
      configurationService.getConfiguration(this.config.uuid, this.$auth.token()).then(configuration => {
        this.sites = configuration.sites || [];
        this.configurationID = configuration.uuid;
        this.otherP2P = configuration.otherP2P || false;
        this.isSiteLoading = false;
      }).catch(() => {
        this.isSiteLoading = false;
      });
    },
    addPublicIP() {
      if (!this.newPublicIP || !this.publicIPValidation) {
        return;
      }
      if (this.modifiedSite.publicIPs.indexOf(this.newPublicIP) === -1) {
        this.modifiedSite.publicIPs.push(this.newPublicIP);
        this.newPublicIP = '';
      }
    },
    removePublicIP(idx) {
      this.modifiedSite.publicIPs.splice(idx, 1);
      this.modifiedSite.publicIPs = this.modifiedSite.publicIPs.slice(0);
    },
    addSubnet() {
      if (!this.newSubnet || !this.subnetValidation) {
        return;
      }
      if (this.modifiedSite.subNetworks.indexOf(this.newSubnet) === -1) {
        this.modifiedSite.subNetworks.push(this.newSubnet);
        this.newSubnet = '';
      }
    },
    removeSubnet(idx) {
      this.modifiedSite.subNetworks.splice(idx, 1);
      this.modifiedSite.subNetworks = this.modifiedSite.subNetworks.slice(0);
    },
    addSite() {
      this.modifiedSite = {
        name: 'Site ' + (this.sites.length + 1),
        uuid: uuidv4(),
        p2pType: 'strict_subnet',
        subNetworks: [],
        publicIPs: []
      };
      this.modificationIndex = -1;
      this.isSiteFormActivated = true;
    },
    modifySite(site, idx) {
      this.modifiedSite = JSON.parse(JSON.stringify(site));
      this.modificationIndex = idx;
      this.isSiteFormActivated = true;
    },
    removeSite(idx, site) {
      const index = idx !== undefined ? idx : this.sites.indexOf(site);
      if (index < 0 || !this.configurationID) {
        return;
      }
      this.sites.splice(index, 1);
      this.sites = this.sites.slice(0);
      configurationService.putConfiguration(this.configurationID, {sites: this.sites}, this.$auth.token()).then(() => {
        this.loadSiteConfiguration();
      }).catch(() => {
        alert(this.$ml.get('errorUpdatingConfigurations'));
      });
    },
    analyticsSite(idx, site) {
      const index = idx !== undefined ? idx : this.sites.indexOf(site);
      if (index < 0 || !this.configurationID) {
        return;
      }
      const filter = this.configurationID + '_' + this.sites[index].uuid;
      this.$router.push('/analytics?site=' + this.sites[index].name + '&filter=' + filter);
    },
    pushSite() {
      if (!this.configurationID) {
        return;
      }
      this.modifiedSite.updatedAt = new Date().toISOString();
      if (this.modificationIndex === -1) {
        this.sites.push(this.modifiedSite);
      } else {
        this.sites[this.modificationIndex] = JSON.parse(JSON.stringify(this.modifiedSite));
        this.sites = this.sites.slice(0);
      }
      configurationService.putConfiguration(this.configurationID, {sites: this.sites}, this.$auth.token()).then(() => {
        this.isSiteFormActivated = false;
        this.loadSiteConfiguration();
      }).catch(() => {
        alert(this.$ml.get('errorUpdatingConfigurations'));
      });
    },
    pushOtherP2P() {
      if (!this.configurationID) {
        return;
      }
      configurationService.putConfiguration(this.configurationID, {otherP2P: this.otherP2P}, this.$auth.token()).then(() => {
      }).catch(() => {
        this.otherP2P = !this.otherP2P;
      });
    },
    getParamsForConfig() {
      if (this.config.rules) {
        for (const key of ['global', 'web', 'android', 'ios']) {
          this.config.rules[key] = this.config.rules[key] || {};
          if (isNaN(this.config.rules[key].cdnSelectorBandwidthFactor)) {
            this.config.rules[key].cdnSelectorBandwidthFactor = 1;
          } else {
            this.config.rules[key].cdnSelectorBandwidthFactor = Math.min(10, Math.round(this.config.rules[key].cdnSelectorBandwidthFactor));
            if (this.config.rules[key].cdnSelectorBandwidthFactor < 0) {
              this.config.rules[key].cdnSelectorBandwidthFactor = 1;
            }
          }
          if (isNaN(this.config.rules[key].cdnSelectorTtfbFactor)) {
            this.config.rules[key].cdnSelectorTtfbFactor = 1;
          } else {
            this.config.rules[key].cdnSelectorTtfbFactor = Math.min(10, Math.round(this.config.rules[key].cdnSelectorTtfbFactor / -10000) );
            if (this.config.rules[key].cdnSelectorTtfbFactor < 0) {
              this.config.rules[key].cdnSelectorTtfbFactor = 1;
            }
          }
        }
        let headers = ['global', 'web', 'android', 'ios', 'authorizations'];
        headers.forEach((header) => {
          if (this.config.rules[header]) {
            this[header] = {...this[header], ...this.config.rules[header]};
            if (header === "authorizations") {
              for (let key2 in this.config.rules[header]) {
                if (key2.indexOf('_') === -1 && this.config.rules[header][key2].length > 0) {
                  this[header + 'Tags']['_' + key2] = this.config.rules[header][key2].map(x => {return {key: "", value:x}})
                }
              }
            }
          }
        })
      }
    },
    getParamsForVideo() {
      if (this.video.rules) {
        for (const key of ['global', 'web', 'android', 'ios']) {
          this.video.rules[key] = this.video.rules[key] || {};
          if (isNaN(this.video.rules[key].cdnSelectorBandwidthFactor)) {
            this.video.rules[key].cdnSelectorBandwidthFactor = 1;
          } else {
            this.video.rules[key].cdnSelectorBandwidthFactor = Math.min(10, Math.round(this.video.rules[key].cdnSelectorBandwidthFactor));
            if (this.video.rules[key].cdnSelectorBandwidthFactor < 0) {
              this.video.rules[key].cdnSelectorBandwidthFactor = 1;
            }
          }
          if (isNaN(this.video.rules[key].cdnSelectorTtfbFactor)) {
            this.video.rules[key].cdnSelectorTtfbFactor = 1;
          } else {
            this.video.rules[key].cdnSelectorTtfbFactor = Math.min(10, Math.round(this.video.rules[key].cdnSelectorTtfbFactor / -10000) );
            if (this.video.rules[key].cdnSelectorTtfbFactor < 0) {
              this.video.rules[key].cdnSelectorTtfbFactor = 1;
            }
          }
        }
        let headers = ['global', 'web', 'android', 'ios', 'authorizations'];
        headers.forEach((header) => {
          if (this.video.rules[header]) {
            this[header] = {...this[header], ...this.video.rules[header]};
            if (header === "authorizations") {
              for (let key2 in this.video.rules[header]) {
                if (key2.indexOf('_') === -1 && this.video.rules[header][key2].length > 0) {
                  this[header + 'Tags']['_' + key2] = this.video.rules[header][key2].map(x => {return {key: "", value:x}})
                }
              }
            }
          }
        })
      }
    },
    getParamsForCollection() {
      if (this.collection.rules) {
        for (const key of ['global', 'web', 'android', 'ios']) {
          this.collection.rules[key] = this.collection.rules[key] || {};
          if (isNaN(this.collection.rules[key].cdnSelectorBandwidthFactor)) {
            this.collection.rules[key].cdnSelectorBandwidthFactor = 1;
          } else {
            this.collection.rules[key].cdnSelectorBandwidthFactor = Math.min(10, Math.round(this.collection.rules[key].cdnSelectorBandwidthFactor));
            if (this.collection.rules[key].cdnSelectorBandwidthFactor < 0) {
              this.collection.rules[key].cdnSelectorBandwidthFactor = 1;
            }
          }
          if (isNaN(this.collection.rules[key].cdnSelectorTtfbFactor)) {
            this.collection.rules[key].cdnSelectorTtfbFactor = 1;
          } else {
            this.collection.rules[key].cdnSelectorTtfbFactor = Math.min(10, Math.round(this.collection.rules[key].cdnSelectorTtfbFactor / -10000) );
            if (this.collection.rules[key].cdnSelectorTtfbFactor < 0) {
              this.collection.rules[key].cdnSelectorTtfbFactor = 1;
            }
          }
        }
        let headers = ['global', 'web', 'android', 'ios', 'authorizations'];
        headers.forEach((header) => {
          if (this.collection.rules[header]) {
            this[header] = {...this[header], ...this.collection.rules[header]};
            if (header === "authorizations") {
              for (let key2 in this.collection.rules[header]) {
                if (key2.indexOf('_') === -1 && this.collection.rules[header][key2].length > 0) {
                  this[header + 'Tags']['_' + key2] = this.collection.rules[header][key2].map(x => {return {key: "", value:x}})
                }
              }
            }
          }
        })
      }
    },
    validateDefaultValues() {
      if (this.global && !this.global.hasOwnProperty("interIsp")) {
        this.global.interIsp = true;
      }
      if (this.global && !this.global.hasOwnProperty("cdnSelectorBandwidthFactor")) {
        this.global.cdnSelectorBandwidthFactor = 1;
      }
      if (this.global && !this.global.hasOwnProperty("cdnSelectorTtfbFactor")) {
        this.global.cdnSelectorTtfbFactor = 1;
      }
      if (this.web && !this.web.hasOwnProperty("cdnSelectorBandwidthFactor")) {
        this.web.cdnSelectorBandwidthFactor = 1;
      }
      if (this.web && !this.web.hasOwnProperty("cdnSelectorTtfbFactor")) {
        this.web.cdnSelectorTtfbFactor = 1;
      }
      if (this.android && !this.android.hasOwnProperty("cdnSelectorBandwidthFactor")) {
        this.android.cdnSelectorBandwidthFactor = 1;
      }
      if (this.android && !this.android.hasOwnProperty("cdnSelectorTtfbFactor")) {
        this.android.cdnSelectorTtfbFactor = 1;
      }
      if (this.ios && !this.ios.hasOwnProperty("cdnSelectorBandwidthFactor")) {
        this.ios.cdnSelectorBandwidthFactor = 1;
      }
      if (this.ios && !this.ios.hasOwnProperty("cdnSelectorTtfbFactor")) {
        this.ios.cdnSelectorTtfbFactor = 1;
      }
    },
    rulesFromParams() {
      const rules = _.cloneDeep({
        global: this.global,
        web: this.web,
        android: this.android,
        ios: this.ios,
        authorizations: this.authorizations
      });
      rules.global.popularity = +this.global.popularity
      rules.global.percentActivated = +this.global.percentActivated
      rules.global.maxUploadPercent = +this.global.maxUploadPercent
      rules.global.cdnSelectorBandwidthFactor = +this.global.cdnSelectorBandwidthFactor
      rules.global.cdnSelectorTtfbFactor = +this.global.cdnSelectorTtfbFactor * -10000

      rules.web.percentActivated = +this.web.percentActivated
      rules.web.maxUploadPercent = +this.web.maxUploadPercent
      rules.web.numberOfSegmentsToKeep = +this.web.numberOfSegmentsToKeep
      rules.web.cdnSelectorBandwidthFactor = +this.web.cdnSelectorBandwidthFactor
      rules.web.cdnSelectorTtfbFactor = +this.web.cdnSelectorTtfbFactor * -10000

      rules.android.percentActivated = +this.android.percentActivated
      rules.android.maxUploadPercent = +this.android.maxUploadPercent
      rules.android.cdnSelectorBandwidthFactor = +this.android.cdnSelectorBandwidthFactor
      rules.android.cdnSelectorTtfbFactor = +this.android.cdnSelectorTtfbFactor * -10000

      rules.ios.percentActivated = +this.ios.percentActivated
      rules.ios.maxUploadPercent = +this.ios.maxUploadPercent
      rules.ios.cdnSelectorBandwidthFactor = +this.ios.cdnSelectorBandwidthFactor
      rules.ios.cdnSelectorTtfbFactor = +this.ios.cdnSelectorTtfbFactor * -10000
      if (this.authorizationsTags._authorizedIPs)
        rules.authorizations.authorizedIPs = this.authorizationsTags._authorizedIPs.map(x => x.value)
      if (this.authorizationsTags._unauthorizedIPs)
        rules.authorizations.unauthorizedIPs = this.authorizationsTags._unauthorizedIPs.map(x => x.value)
      if (this.authorizationsTags._authorizedCountries)
        rules.authorizations.authorizedCountries = this.authorizationsTags._authorizedCountries.map(x => x.value)
      if (this.authorizationsTags._unauthorizedCountries)
        rules.authorizations.unauthorizedCountries = this.authorizationsTags._unauthorizedCountries.map(x => x.value)
      if (this.authorizationsTags._whitelistedWebsites)
        rules.authorizations.whitelistedWebsites = this.authorizationsTags._whitelistedWebsites.map(x => x.value)
      if (this.authorizationsTags._blacklistedWebsites)
        rules.authorizations.blacklistedWebsites = this.authorizationsTags._blacklistedWebsites.map(x => x.value)
      if (this.authorizationsTags._authorizedVPNsList)
        rules.authorizations.authorizedVPNsList = this.authorizationsTags._authorizedVPNsList.map(x => x.value)
      return rules;
    },
    pushParams() {
      const rules = this.rulesFromParams()
      switch(this.type) {
        case 'config':
          configurationService.putConfiguration(this.config.uuid, { rules }, this.$auth.token())
          .then((response) => {
            this.initialState = this.captureState();
            this.showModal("successParameters");
            console.log("Configuration updated");
          }).catch(err => {
            alert(this.$ml.get('errorUpdatingConfigurations'));
          })
          break;
        case 'video':
          videoService.putVideoPlugin({
            rules: rules,
            rulesFromCollection: ""
          }, this.video, this.$auth.token())
          .then((response) => {
            //this.video = response;
            console.log("Video updated", response);
              this.$emit('rulesChange');
              this.$emit('closeModal', true);
          }).catch(err => {
            alert(this.$ml.get('errorUpdatingVideo'));
          })
          break;
        case 'collection':
          if (this.collection.uuid) {
            collectionService.putCollection(this.collection.uuid, { rules }, this.$auth.token())
            .then((response) => {
              console.log("Collection updated");
              this.$emit('closeModal', true)
            }).catch(err => {
              alert(this.$ml.get('errorUpdatingConfig'));
            })
          }
          else {
            collectionService.postCollection({ ...this.collection, rules }, this.$auth.token())
            .then((response) => {
              console.log("Collection updated");
              this.$emit('closeModal', true)
            }).catch(err => {
              alert(this.$ml.get('errorUpdatingConfig'));
            })
          }
          break;
          /*videoService.putVideoPluginByCollection( {
            rules: {
              global: this.global,
              web: this.web,
              android: this.android,
              ios: this.ios,
              authorizations: this.authorizations
            }
          }, this.collection, this.$auth.token())
          .then((response) => {
            console.log("Collection updated");
            this.$emit('closeModal', true)
          }).catch(err => {
            alert('Error while updating collection. Please retry later.');
          })*/
        default:
          break;
      }
    },
    defaultParams() {
      switch (this.type) {
        case 'video':
          videoService.putVideoPlugin({
            rules: null,
            rulesFromCollection: "",
          }, this.video, this.$auth.token())
            .then((response) => {
              //this.video = response;
              console.log("Video updated", response);
              this.$emit('rulesChange');
              this.$emit('closeModal', true);
            }).catch(err => {
            alert(this.$ml.get('errorUpdatingVideo'));
            })
          break;
        case 'collection':
          /*videoService.putVideoPluginByCollection( {
            rules: null
          }, this.collection, this.$auth.token())
          .then((response) => {
            console.log("Collection updated");
            this.$emit('closeModal', true)
          }).catch(err => {
            alert('Error while updating collection. Please retry later.');
          })*/
          break;
        default:
          break;
      }
    }
  },
};
</script>

<style scoped>
.leftcolumn {
  background-color: rgba(0,37,69,0.1);
  border-radius: 10px;
  padding-top: 10px;
  padding-bottom: 10px;
  font-size:small;
  margin-bottom: 10px;
}

.selectable {
  padding: 10px;
  border-radius: 4px;
  cursor: pointer;
  font-size: small;
}

.selectable-site {
  margin-top: 0.35rem;
}

.left-separator {
  border-top: 1px solid rgba(0, 37, 69, 0.24);
  margin-top: 0.45rem;
  margin-bottom: 0.35rem;
}

.selectable:hover {
  background-color: rgba(0,37,69,0.1);
  border: 1px solid white;
}

.selected {
  background-color: #007bff; /* Bootstrap blue background color */
  color: #fff; /* White text color */
  border: 1px solid white;
  font-size: small;
  box-shadow: rgba(15, 24, 47, 0.12) 1px 2px 7px, rgba(15, 24, 47, 0.12) 1px 2px 7px;
}

.prevent-range-title {
  font-size: small;
  font-weight: 500;
  color: #21405f;
}

.global-panel {
  padding: 0.4rem 0.2rem 0.2rem;
  font-size: 0.82rem;
  font-weight: 500;
  color: #21405f;
  text-align: left;
}

.global-activation-row {
  justify-content: flex-start;
  flex-wrap: wrap;
  row-gap: 0.45rem;
  margin-left: 0;
  margin-right: 0;
  margin-bottom: 2rem;
}

.global-status-text {
  font-size: 0.82rem;
  font-weight: 500;
  line-height: 1.25;
  margin-right: 0.4rem;
  text-align: left;
}

.global-popularity-row {
  font-size: small;
  margin-left: 0;
  margin-right: 0;
  margin-bottom: 1rem;
}

.global-popularity-input {
  width: 200px;
  max-width: 100%;
}

.prevent-range-heading {
  margin-left: 0;
  margin-right: 0;
  margin-bottom: 0.35rem;
}

.prevent-range-list {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-bottom: 0.35rem;
}

.prevent-range-card {
  padding: 0.9rem 1rem;
  border: 1px solid rgba(0, 37, 69, 0.12);
  border-radius: 12px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.96) 0%, rgba(242, 247, 252, 0.92) 100%);
  box-shadow: 0 10px 24px rgba(15, 24, 47, 0.06);
}

.prevent-range-row {
  row-gap: 0.75rem;
}

.prevent-field {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  height: 100%;
  margin-bottom: 0;
  font-size: small;
}

.prevent-field label {
  display: block;
  margin-bottom: 0.35rem;
  font-size: 0.78rem;
  font-weight: 500;
  color: #39556f;
}

.prevent-input {
  min-height: 38px;
  font-size: 0.82rem;
  border-radius: 10px;
  border-color: rgba(0, 37, 69, 0.16);
  box-shadow: none;
}

.prevent-input:focus {
  border-color: rgba(0, 123, 255, 0.45);
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.12);
}

.prevent-toggle {
  display: inline-flex;
  align-items: center;
  gap: 0.55rem;
  min-height: 38px;
  padding: 0.7rem 0.85rem;
  border-radius: 10px;
  background: rgba(0, 37, 69, 0.05);
  font-size: small;
}

.prevent-toggle input {
  margin: 0;
}

.prevent-toggle-input {
  width: 16px;
  height: 16px;
  flex: 0 0 auto;
}

.prevent-toggle-label {
  margin: 0;
  font-size: 0.8rem;
  font-weight: 500;
  color: #21405f;
  cursor: pointer;
  line-height: 1.2;
}

.prevent-action-col {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  min-height: 100%;
  padding-bottom: 0;
}

.prevent-remove-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  min-width: 38px;
  height: 38px;
  padding: 0 !important;
  align-self: flex-end;
}

.prevent-add-btn {
  border-radius: 999px;
  padding-left: 0.9rem;
  padding-right: 0.9rem;
  margin-top: 0;
}

.interisp-row {
  display: flex;
  align-items: center;
  gap: 0.45rem;
  margin-left: 0;
  margin-right: 0;
  margin-bottom: 0.6rem;
  font-size: small;
}

.global-divider {
  margin-top: 1rem;
  margin-bottom: 1.2rem;
}

.global-range-group {
  margin-left: 0;
  margin-right: 0;
  margin-bottom: 1rem;
  font-size: small;
}

.global-range-group label {
  display: inline-block;
  margin-bottom: 0.4rem;
  color: #21405f;
  font-weight: 500;
}

.range-value-row {
  margin-top: 0.2rem;
}

.range-value-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 62px;
  padding: 0.15rem 0.55rem;
  border-radius: 999px;
  background: rgba(0, 37, 69, 0.08);
  color: #21405f;
  font-size: 0.78rem;
  font-weight: 500;
}

.global-check-row {
  display: flex;
  align-items: center;
  gap: 0.45rem;
  margin-left: 0;
  margin-right: 0;
  font-size: small;
  margin-bottom: 0.3rem;
}

.sdk-panel {
  font-size: 0.82rem;
  font-weight: 500;
  color: #21405f;
  text-align: left;
}

.sdk-activation-row {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 0.35rem;
  row-gap: 0.45rem;
  margin-left: 0;
  margin-right: 0;
  margin-top: 1rem;
  margin-bottom: 2rem;
  font-size: small;
}

.sdk-status-text {
  font-size: 0.82rem;
  font-weight: 500;
  line-height: 1.25;
  margin-right: 0.4rem;
  text-align: left;
}

.sdk-form-group {
  margin-left: 0;
  margin-right: 0;
  margin-bottom: 1rem;
  font-size: small;
}

.sdk-form-group label {
  display: inline-block;
  margin-bottom: 0.4rem;
  color: #21405f;
  font-weight: 500;
}

.sdk-check-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  column-gap: 0.45rem;
  margin-left: 0;
  margin-right: 0;
  margin-bottom: 1rem;
  font-size: small;
  width: 100%;
  max-width: 360px;
}

.sdk-check-row label {
  margin: 0;
  line-height: 1.2;
}

.sdk-divider {
  margin-top: 0.2rem;
  margin-bottom: 1.15rem;
}

.panel-checkbox-label {
  margin: 0;
  font-size: 0.82rem;
  font-weight: 500;
  line-height: 1.2;
  text-align: left;
}

.panel-checkbox-input {
  width: 16px;
  height: 16px;
  margin: 0;
  flex: 0 0 auto;
}

.site-panel-scroll {
  max-height: 58vh;
  overflow-y: auto;
  padding-right: 0.2rem;
}

.site-panel-header {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  font-size: 0.9rem;
  color: #21405f;
  margin-bottom: 0.45rem;
}

.site-help-text {
  font-size: 0.78rem;
  margin-bottom: 0;
}

.site-table {
  font-size: 0.78rem;
  margin-top: 0.5rem;
  margin-bottom: 0.6rem;
}

.site-form {
  font-size: 0.78rem;
}

.otherP2P {
  border-top: 1px solid rgba(47,144,176,1);
  border-bottom: 1px solid rgba(47,144,176,1);
  background-color: rgba(47,144,176,0.18);
  padding: 0.6rem 0.75rem 0.6rem 2.35rem;
}

.ip {
  background-color: rgba(47,144,176,1);
  border-radius: 5px;
  color: white;
  padding: 4px 6px;
}

.ipremove {
  cursor: pointer;
  margin-left: 10px;
  font-weight: 500;
}

.ipremove:hover {
  color: #ba0000;
}

::v-deep .parameters-modal .modal-content {
  background: rgba(15, 23, 42, 0.94);
  color: #ffffff;
  border: 1px solid rgba(203, 213, 225, 0.35);
  border-radius: 10px;
  box-shadow: 0 8px 22px rgba(2, 6, 23, 0.35);
}

::v-deep .parameters-modal .modal-header {
  border-bottom: 1px solid rgba(203, 213, 225, 0.2);
  padding: 0.85rem 1rem;
}

::v-deep .parameters-modal .modal-title {
  font-size: 0.96rem;
  color: #ffffff;
  font-weight: 600;
}

::v-deep .parameters-modal .close {
  color: #ffffff;
  text-shadow: none;
}

::v-deep .parameters-modal .modal-body {
  padding: 1rem 1rem 0.95rem;
}

.parameters-modal-text {
  display: block;
  line-height: 1.45;
  color: #ffffff;
  margin-bottom: 0.1rem;
}

.parameters-modal-divider {
  margin: 0.75rem 0 0.9rem;
  border-color: rgba(203, 213, 225, 0.25);
}

.parameters-modal-actions {
  margin-bottom: 0.15rem;
}

.parameters-modal-close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.35rem;
}

.parameters-modal-close-icon {
  margin-right: 0;
}

@media (max-width: 991px) {
  .global-activation-row {
    margin-bottom: 1.25rem;
  }

  .sdk-activation-row {
    margin-bottom: 1.25rem;
  }

  .global-popularity-input {
    width: 100%;
  }

  .prevent-action-col {
    justify-content: flex-start;
  }

  .prevent-toggle {
    width: 100%;
  }

  .global-divider {
    margin-top: 0.8rem;
  }
}

</style>
